import React from 'react';

const Home = () => {
  return (
    <div>这里是 Home
    </div>
  )
};

export default Home;
